module.exports = __webpack_public_path__ + "img/camel-comb3-2.5b67cf40.jpg";